import React, {useEffect, useState} from 'react';

// custom components
import {Footer, Text, PageNavigator } from '../../components/atoms';
import { ApiTitle, TabList, List, TableNumber, Callout, RequestHeader, RequestFields, HttpRequest} from '../../components/molecules';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import SwaggerUI from "swagger-ui-react";

// custom components //
import { Maintenance } from '../../components/atoms';
import { IntegrationRow } from '../../components/organisms';

// code
import sample from '../../utils/code/postBookingBody';
import { CopyBlock, dracula} from "react-code-blocks";

// utils
import { Colors } from '../../styles';

// images
import GettingPRMBookings from '../../assets/images/getting-bookings/getting-bookings-cycle-period.png';

const codeStyle = {
    fontFamily: 'monospace',
    fontSize: 16,
    backgroundColor: '#f0f0f0',
    color: "#000000",
    padding: 4,
    borderRadius: 4
};


const GettingBookings = (props) => {

    const [tab, setTab] = useState(0)

    useEffect(() => {

    }, []);

    const TitleText = (props) => { return ( <p style={{ fontWeight:'bold', fontSize:14 }}>{props.children}</p>)}
    const TextText = (props) => { return ( <p style={{ fontWeight:'300', fontSize:14 }}>{props.children}</p>)}

    const ExampleBookingTable = (props) => {

        const Row = (props) => { return (
            <tr>
                <td><TitleText>{props.data}</TitleText></td>
                <td><TextText>{props.example}</TextText></td>
            </tr>
        )}

        return (
            <div style={{ }}>
                <table class="table" style={{ }}>
                        <thead style={{}}>
                            <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                                <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Data</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Value</th>
                            </tr>
                        </thead>
                    <tbody>
                        <tr>
                            <td><TitleText>{'Booking Id'}</TitleText></td>
                            <td><TextText>{'EI205-2022-01-01-joe-bloggs'}</TextText></td>
                        </tr>
                        <Row data={'Passenger Name'} description={'The name of the passenger'} example={'Mr. Joe Bloggs'} required={'Yes'} />
                        <Row data={'Origin Airport IATA'} description={'The IATA code of the origin airport'} example={'DUB'} required={'Yes'} />
                        <Row data={'Destination Airport IATA'} description={'The IATA code of the destination airport'} example={'JFK'} required={'Yes'} />
                        <Row data={'Flight Number'} description={'The flight number of the route'} example={'EI105'} required={'Yes'} />
                        <Row data={'Departure Date'} description={'The departure date of the flight'} example={'07-12-2022'} required={'Yes'} />
                        <Row data={'Assistance Requested'} description={'A list of SSR codes.'} example={'[ Wheelchair Access, Impaired Eyesight]'} required={'Yes'} />
                        <Row data={'Equipment Information'} description={'Details of the passengers wheelchair equipment'} example={'Make, Model, Weight, Battery etc.'} required={'Optional'} />
                        <Row data={'Service Animal'} description={'Wether or not the passenger is accomponanied by a service animal'} example={'False'} required={'Optional'} />
                    </tbody>
                </table>
            </div>
        )
    }

    const ResponseTable = (props) => {
        return (
            <div>
                <table class="table" style={{ }}>
                    <thead style={{}}>
                        <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                            <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Code</Text.TableHeader></th>
                            <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Description</Text.TableHeader></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>200 Ok</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Returns the queried bookings and or the counts of bookings for corresponding days.'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>400 Bad Request</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>Indicates that there was an error in the request. </Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>403 Unauthorized Access</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the request is unauthorized. Typically the result of not including the Authorization header in the request.'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>404 Not Found</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that no bookings matching the query were found.'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>500 Internal Server Error</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the request did not go through due to an internal error.'}</Text.TableBody></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    return (
        <>
            {/* Title and Prerequisities */}
            <Row className='mt-5'>
                <Col>
                    <ApiTitle 
                        smallTitle={'GET Request'}
                        title={'Getting multiple bookings'}
                        subtitle={'Use this guide to learn how to get multiple PRM booking using different filters or query parameters.'}
                        prerequisitesTitle={'Available Filters'}
                        prerequisites={[
                            'Airport Code (IATA)',
                            'Outbound or Inbound',
                            'Start Date & End Date',
                            'Airline Carrier Code'
                        ]}
                    />
                </Col>
            </Row>

            {/* Overview */}
            <Row>
                <Col>
                    <Text.Subheading>Overview</Text.Subheading>
                    <Text.Text>{`In this section, we aim to retrieve multiple bookings using the PRM Connect Database. The previous section examined returning singular bookings using an id, in this section instead we use multiple query parameters to return a list of bookings which satisfy the filters.`}</Text.Text>
                </Col>
            </Row>
            
            {/* Selector Tab List */}
            <Row>
                <Col>
                    <TabList 
                        tabs={['Overview', 'Example', 'Implementation']}
                        setTab={(value)=>{ setTab(value)}}
                    />
                </Col>
            </Row>

            { tab == 1 && 
            <>
            <Row className='mt-4'>
                <Col>
                    <Container>
                        <Text.Subheading>1. Authorization</Text.Subheading>
                        <Text.Text>{'Authentication is achieved by means of a JSON Web Token: '}</Text.Text>
                        <Container>
                            <List list={['Bearer <token>']} />
                        </Container>
                    </Container>
                </Col>
            </Row>

            {/* 2. Request */}
            <Row className='mt-3'>
                <Col>
                    <Container>
                        <Text.Subheading>2. Request</Text.Subheading>
                        <Text.Text>{'This section describes the Get Booking API, an example request and response, JSON schemas for request and responses and error response codes.'}</Text.Text>              
                    </Container>
                </Col>
            </Row>
            
            {/* 3.1 Headers */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.1 Request Query Parameters</Text.Subheading>
                        <Text.Text>{'The request contains the following query parameters:'}</Text.Text>
                        <RequestFields rows={[
                            { parameter:'iata', description:'The 3 letter IATA code of the appropriate airport', example:'DUB', optional:'Required' },
                            { parameter:'type', description:'Whether the booking is inbound, outbound, or all. Defaults to all', example:'inbound', optional:'Optional'},
                            { parameter:'start', description:'A start date in the format YYYY-MM-DD.', example:'2023-01-03', optional:'Required'},
                            { parameter:'end', description:'An end date in the format YYYY-MM-DD (non inclusive)', example:'2023-01-10', optional:'Optional'},
                            { parameter:'carrierCode', description:'The 2 letter IATA code or 3 letter ICAO code of an airline', example:'IE', optional:'Optional'},
                            { parameter:'count_by', description:'A field by which to count bookings. Leave empty to not count the bookings. Currently only flightDetails.departureDate is supported.', example:'flightDetails.departureDate', optional:'Optional'},
                            { parameter:'counts_only', description:'Whether to only return the counts. Defaults to false', example:'True', optional:'Optional'},
                            { parameter:'skip', description:'Skips this number of bookings before starting to return the results. Default is 0', example:'100', optional:'Optional'},
                            { parameter:'limit', description:'The limit on the number of matching results. This does not affect the counts. Defaults to 25', example:'300', optional:'Optional'},
                        ]}
                        />
                        <Text.Text>{'The skip and limit fields can be used to implement pagination where queries return a large number of matchings bookings.'}</Text.Text>
                    </Container>
                </Col>
            </Row>

            {/* 3.2 Body */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.2 Request Body</Text.Subheading>
                        <Text.Text>{'The request body is empty.'}</Text.Text>
                    </Container>
                </Col>
            </Row>

            {/* 3.3 Response */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.3 Request Response</Text.Subheading>
                        <Text.Text>{'This section reviews the different responses and their meaning.'}</Text.Text>
                        <ResponseTable />
                    </Container>
                </Col>
            </Row>
            </>
            }

            { tab == 2 &&
            <>
            <Row className='mt-4'>
                <Col >
                   <Container>

                       {/* Text */}
                       <Text.Subheading>1. Example Request</Text.Subheading>
                       <Text.Text>{'This section contains an example of requesting a passenger booking using the booking id.'}</Text.Text>

                       <Text.Subsubheading>1.1 Getting all of an airlines bookings in an airport for a month</Text.Subsubheading>
                       <Text.Text>{'In this example we get all of the Aer Lingus bookings for Dublin Airport in January 2023. This is done by setting the query parameters to match our airport, airline and time period.'}</Text.Text>
                       
                       <Text.Subsubheading>1.2 Request</Text.Subsubheading>
                       <HttpRequest 
                            requestType={'GET'}
                            url={'https://connect.prmassist.com/api/v1/bookings?iata=DUB&start=2023-01-01&end2023-02-01'}
                            headers={['Authorization: Bearer <token>', 'Content-Type: application/json']}
                        />
                   </Container>
               </Col>
           </Row>
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <TableNumber title={'1.1 Request Response'} description={'Displays the response from the above request'} />
                        <CopyBlock
                            language={'json'}
                            text={sample['multipleBookingsResponse']}
                            showLineNumbers={false}
                            theme={dracula}
                            wrapLines={false}
                        />
                    </Container>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col >
                   <Container>

                       <Text.Subsubheading>1.2 Counting all of an airlines outbound bookings in an airport for a month</Text.Subsubheading>
                       <Text.Text>{'In the example, we want to get bookings for Dublin, and we want to count them, grouped by their departure date. In the response, we receive the matching bookings in the data field, and the counts grouped by departure date in the counts field.'}</Text.Text>
                       <HttpRequest 
                            requestType={'GET'}
                            url={'https://connect.prmassist.com/api/v1/bookings?iata=DUB&start=2023-01-20&end2023-02-21&count_by=flightDetails.departureDate'}
                            headers={['Authorization: Bearer <token> ', 'Content-Type: application/json']}
                        />
                   </Container>
               </Col>
           </Row>
           <Row className='mt-2'>
                <Col>
                    <Container>
                        <TableNumber title={'1.2 Request Response'} description={'Displays the response from the above request'} />
                        <CopyBlock
                            language={'json'}
                            text={sample['multipleBookingCountResponse']}
                            showLineNumbers={false}
                            theme={dracula}
                            wrapLines={false}
                        />
                        <div className='mt-3'>
                            <Text.Text>To only include the counts and not the matching bookings, include the query parameter <span style={codeStyle}>counts_only=true</span> to only return the counts field in the response.</Text.Text>
                        </div>
                    </Container>
                </Col>
            </Row>
            </>
            }


            {/* Request */}
            { tab === 3 &&
            <>
                <Row className='mt-4'>
                    <Col>
                        <Container>
                            <Text.Subheading>Swagger Implementation</Text.Subheading>
                            <Text.Text>{'This section contains a swagger that can be used for getting a single booking using a booking id, reviewing the different responses and error codes'}</Text.Text>
                            <SwaggerUI url="bulk_get_bookings.yaml" />
                        </Container>
                    </Col>
                </Row>
            </>
            }

            {/* Integration */}

            {/* Page Navigator */}
            <Row>
                <Col>
                    <Container>
                        <PageNavigator leftText={'Getting a Booking'} leftLink={'/getting-a-booking'}  rightText={''} rightLink={'/'} />
                    </Container>
                </Col>
            </Row>
            
            <Footer small={true} />
        </>
    );
};

export default GettingBookings;
